import {HTTP} from '@/utils/httpCommonUtil';

export default {
  data () {
    return {
      loadingInitialData: false
    };
  },
  methods: {
    async execute(verb: string, url: string, error: string, body?: any, hideLoaderWhenSuccessful = true, showLoader = true): Promise<any | undefined> {
      let showLoadingSpinnerTimeout = setTimeout(() => {
        (this as any).loadingInitialData = showLoader;
      }, 150);
      try {
        const response = await (HTTP as any)[verb]('/api' + url, body);
        clearTimeout(showLoadingSpinnerTimeout);
        (this as any).loadingInitialData = !hideLoaderWhenSuccessful;
        if (!response.data || (verb !== 'delete' && !response.data.data)) {
          if (response.data && response.data.message) {
            error = response.data.message;
          }
          throw new Error(error);
        }
        if (response.data.success) {
          return response.data;
        } else {
          throw new Error(error);
        }
      } catch (err) {
        clearTimeout(showLoadingSpinnerTimeout);
        (this as any).loadingInitialData = false;
        if (err.response && err.response.status === 422 && err.response.data) {
          return err.response.data;
        }
        if (err.response && err.response.data && err.response.data.message) {
          error = err.response.data.message;
        }
        (this as any).$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: error
        });
        return undefined;
      }
    },
    async httpGetArray(url: string, error: string, hideLoaderWhenSuccessful = true): Promise<any[]> {
      const data = this.httpGet(url, error, hideLoaderWhenSuccessful) as any;
      return data || [];
    },
    async httpGet<T>(url: string, error: string, hideLoaderWhenSuccessful = true, showLoader = true): Promise<T | undefined> {
      const results = await this.execute('get', url, error, null, hideLoaderWhenSuccessful, showLoader);
      if (results) {
        return results.data;
      }
    },
    async httpPost<T>(url: string, error: string, body?: any, hideLoaderWhenSuccessful = true, showLoader = true): Promise<T | undefined> {
      const results = await this.execute('post', url, error, body, hideLoaderWhenSuccessful, showLoader);
      if (results) {
        return results.data;
      }
    },
    async httpPut<T>(url: string, error: string, body?: any, hideLoaderWhenSuccessful = true, showLoader = true): Promise<T | undefined> {
      const results = await this.execute('put', url, error, body, hideLoaderWhenSuccessful, showLoader);
      if (results) {
        return results.message;
      }
    },
    async httpDelete<T>(url: string, error: string, hideLoaderWhenSuccessful = true, showLoader = true): Promise<T | undefined> {
      const results = await this.execute('delete', url, error, null, hideLoaderWhenSuccessful, showLoader);
      if (results) {
        return results.message;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/mixins/HttpMixin.ts